import api from './axios';
import { GetMarginUrlResponse, UpdateMarginUrlRequest, UpdateMarginUrlResponse, MarginV2Response } from './types'

const marginApi = {
    getMarginUrl: async (business_id?: string): Promise<GetMarginUrlResponse> => {
        try {
            const config = business_id ? { params: { business_id } } : {};
            const response = await api.get<GetMarginUrlResponse>('/margin/url', config);
            return response.data;
        } catch (error: any) {
            console.error('Failed to fetch margin sheet URL:', error);
            throw new Error('Unable to retrieve margin sheet URL');
        }
    },

    updateMarginUrl: async (
        data: UpdateMarginUrlRequest, business_id?: string
    ): Promise<UpdateMarginUrlResponse> => {
        try {
            const config = business_id ? { params: { business_id } } : {};
            const response = await api.put<UpdateMarginUrlResponse>('/margin/url', data, config);
            return response.data;
        } catch (error: any) {
            console.error('Failed to update margin sheet URL:', error);
            throw new Error('Unable to update margin sheet URL');
        }
    },

    syncFromSheet: async (business_id?: string): Promise<any> => {
        try {
            const config = business_id ? { params: { business_id } } : {};
            const response = await api.post('/margin/sync-from-sheet', null, config);
            return response.data;
        } catch (error: any) {
            console.error('Failed to sync from sheet:', error);
            throw new Error('Unable to sync data from sheet');
        }
    },

    syncMargin: async (periodStart?: string, business_id?: string): Promise<any> => {
        try {
            const params: Record<string, string> = {};
            if (periodStart) params.period_start = periodStart;
            if (business_id) params.business_id = business_id;
            const response = await api.post('/margin/sync', null, { params });
            return response.data;
        } catch (error: any) {
            console.error('Failed to sync margin data:', error);
            throw new Error('Unable to sync margin data');
        }
    },

    getMarginV2: async (year?: number, month?: number, business_id?: string): Promise<MarginV2Response> => {
        try {
            const params: Record<string, any> = {};
            if (year) params.year = year;
            if (month) params.month = month;
            if (business_id) params.business_id = business_id;

            const response = await api.get<MarginV2Response>('/margin/v2', { params });
            return response.data;
        } catch (error: any) {
            console.error('Failed to fetch margin v2 data:', error);
            throw new Error('Unable to fetch margin data');
        }
    },

    syncMarginV2: async (year?: number, month?: number, business_id?: string): Promise<MarginV2Response> => {
        try {
            const params: Record<string, any> = {};
            if (year) params.year = year;
            if (month) params.month = month;
            if (business_id) params.business_id = business_id;

            const response = await api.get<MarginV2Response>('/margin/v2/sync', { params });
            return response.data;
        } catch (error: any) {
            console.error('Failed to sync margin v2 data:', error);
            throw new Error('Unable to sync margin data');
        }
    },
};

export default marginApi;
